import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NbAccordionModule,
  NbAlertModule,
  NbBadgeModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbContextMenuModule,
  NbDatepickerModule,
  NbDialogModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbLayoutModule,
  NbListModule,
  NbMenuModule,
  NbSelectModule,
  NbSpinnerModule,
  NbTabsetModule,
  NbTagModule,
  NbPopoverModule,
} from '@nebular/theme';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { DynamicListViewModule } from '../../shared/component/dynamiclistview/dynamiclistview.module';
import { DynamicInputModule } from '../../shared/component/dynamiclistview/dynamic-input/dynamic-input.module';
import { EquipmentCountingJournalRoutingModule } from './equipment-counting-journal-routing.module';
import { EquipmentCountingJournalListComponent } from './equipment-counting-journal-list/equipment-counting-journal-list.component';
import { EquipmentCountingJournalBatchCreateComponent } from './components/equipment-counting-journal-batch-create/equipment-counting-journal-batch-create.component';
import { JournalDetailsComponent } from './components/journal-details/journal-details.component';
import { JournalLineDetailComponent } from './components/journal-line-detail/journal-line-detail.component';
import { EquipmentIssueDialogComponent } from './components/equipment-issue-dialog/equipment-issue-dialog.component';
import { EquipmentCountingMetricsComponent } from './components/equipment-counting-metrics/equipment-counting-metrics.component';
import { MetricDetailLinesComponent } from './components/metric-detail-lines/metric-detail-lines.component';
import { LostEquipmentDetailsModalComponent } from './components/lost-equipment-details-modal/lost-equipment-details-modal.component';
import { NotFoundEquipmentDetailsModalComponent } from './components/not-found-equipment-details-modal/not-found-equipment-details-modal.component';
import { SlicerComponentModule } from '../inventory/components/slicer/slicer.component.module';
import { AttachmentsModule } from '../attachments/attachments.module';
import { EquipmentCountingSlicersComponent } from './components/equipment-counting-slicers/equipment-counting-slicers.component';
import { WorkerCountingAnalyticsComponent } from './components/worker-counting-analytics/worker-counting-analytics.component';

@NgModule({
  declarations: [
    EquipmentCountingJournalListComponent,
    EquipmentCountingJournalBatchCreateComponent,
    JournalDetailsComponent,
    JournalLineDetailComponent,
    EquipmentCountingMetricsComponent,
    MetricDetailLinesComponent,
    LostEquipmentDetailsModalComponent,
    NotFoundEquipmentDetailsModalComponent,
  ],
  exports: [EquipmentIssueDialogComponent],
  imports: [
    EquipmentIssueDialogComponent,
    CommonModule,
    EquipmentCountingJournalRoutingModule,
    NbAccordionModule,
    NbCardModule,
    NbButtonModule,
    NbContextMenuModule,
    NbFormFieldModule,
    NbIconModule,
    NbInputModule,
    NbMenuModule,
    NbSelectModule,
    NbListModule,
    NbLayoutModule,
    NbSpinnerModule,
    NbTabsetModule,
    NbCheckboxModule,
    NbDatepickerModule,
    NbBadgeModule,
    NbTagModule,
    NbDialogModule.forChild(),
    FormsModule,
    NbAlertModule,
    ReactiveFormsModule,
    SharedModule,
    DynamicListViewModule,
    DynamicInputModule,
    SlicerComponentModule,
    AttachmentsModule,
    NbPopoverModule,
    EquipmentCountingSlicersComponent,
    WorkerCountingAnalyticsComponent,
  ],
})
export class EquipmentCountingJournalModule {}
